// extracted by mini-css-extract-plugin
export default {"headline":"headline___MzsuD","small":"small___3ND7X","large":"large___1zVFY","bold":"bold___3prAv"};